import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import { IconButton } from '@mui/material';

interface ButtonRenderProps {
  size: string;
  isMid?: boolean;
  xPos?: string;
  iconSize?: string;
  leftFunction: () => void;
  rightFunction: () => void;
  isTransparent: boolean;
}
//Render Left and Right arrow button
export const ButtonRender: React.FC<ButtonRenderProps> = ({
  size,
  xPos,
  isMid,
  iconSize,
  leftFunction,
  rightFunction,
  isTransparent,
}) => {
  return (
    <>
      <IconButton
        onClick={(e) => {
          e.stopPropagation();
          leftFunction();
        }}
        sx={{
          width: size,
          height: size,
          position: 'absolute',
          left: xPos,
          top: isMid ? '50%' : '',
          backgroundColor: isTransparent
            ? 'rgb(230,230,230,0.7)'
            : 'rgb(255,255,255,1)',
          zIndex: 1, // ensure icon stays on top of image
          '&:hover .left-arrow': { color: '#000' }, // Change color on hover
          '&:hover': { opacity: 1, backgroundColor: '#FDFDFD' },
        }}
      >
        <KeyboardArrowLeft
          className="left-arrow"
          sx={{ color: '#000', fontSize: iconSize }}
        />
      </IconButton>
      <IconButton
        onClick={(e) => {
          e.stopPropagation();
          rightFunction();
        }}
        sx={{
          width: size,
          height: size,
          position: 'absolute',
          right: xPos,
          top: isMid ? '50%' : '',
          backgroundColor: isTransparent
            ? 'rgb(230,230,230,0.7)'
            : 'rgb(255,255,255,1)',
          zIndex: 1, // ensure icon stays on top of image
          '&:hover .right-arrow': { color: '#000' }, // Change color on hover
          '&:hover': { opacity: 1, backgroundColor: '#FDFDFD' },
        }}
      >
        <KeyboardArrowRight
          className="right-arrow"
          sx={{ color: '#000', fontSize: iconSize }}
        />
      </IconButton>
    </>
  );
};

export default ButtonRender;
